import {Component, forwardRef, Host, Input, OnInit, Optional, SkipSelf} from '@angular/core';
import {ControlContainer, NG_VALUE_ACCESSOR} from '@angular/forms';
import { inputMgsErrs } from 'src/app/validators/message-validation';
import {FormComponentControl} from '../form-component-control';

@Component({
  selector: 'app-input-gender',
  templateUrl: './input-gender.component.html',
  styleUrls: ['./input-gender.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputGenderComponent),
      multi: true
    }
  ]
})
export class InputGenderComponent extends FormComponentControl implements OnInit {
  @Input() isDisabled: boolean;
  @Input() name: any = 'gender';
  errors = inputMgsErrs.gender;

  constructor(
    @Optional() @Host() @SkipSelf()
    private cc: ControlContainer
  ) {
    super(cc);
  }

  ngOnInit() {
    this.checkInitialControl();
  }

  selectGender(val) {
    if (!this.isDisabled) {
      this.value = val;
    }
  }

}
